import {
  Component,
  inject,
  isDevMode,
  Renderer2,
  ViewChild,
  OnInit,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';
import {
  IxConfirmationComponent,
  IxFavoriteListComponent,
  IxKeyboardShortcutsService,
  IxNgComValidationService,
  IxNgConfirmationService,
  IxNgFavoriteListService,
  IxNgHtmlUtilsService,
  IxNgMenuService,
  IxNgNavigationService,
  IxNgShortcutsService,
  IxToastComponent,
  PRIORITY_GLOBAL,
  ShortcutBindings,
} from 'ix-ng-components';
import { RouterOutlet } from '@angular/router';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { Button } from 'primeng/button';
import { AppService } from '../services/app.service';
import { AppTopBarComponent } from '../topbar/app.topbar.component';
import { AppTopBarBotComponent } from '../topbar-bot/app.topbar-bot.component';
import { FooterComponent } from '../footer/footer.component';
import { LayoutService } from './layout.service';
import { IxNgValidationService } from 'ix-ng-forms';
import {
  AktivnaNujnaObvestilaComponent,
  AppMenuComponent,
  BlockUiService,
  ValidationDialog,
} from 'arsktrp-shared-components';
import { AsyncPipe, NgClass, NgStyle } from '@angular/common';
import { BlockUI } from 'primeng/blockui';

@Component({
  selector: 'lib-layout',
  templateUrl: './layout.html',
  imports: [
    RouterOutlet,
    ValidationDialog,
    IxConfirmationComponent,
    ConfirmDialog,
    Button,
    FooterComponent,
    AppMenuComponent,
    IxFavoriteListComponent,
    AppTopBarComponent,
    AppTopBarBotComponent,
    NgClass,
    NgStyle,
    BlockUI,
    AsyncPipe,
    IxToastComponent,
    AktivnaNujnaObvestilaComponent,
  ],
  styleUrls: ['./layout.scss'],
})
export class Layout implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('appTopBar')
  public appTopBar?: AppTopBarComponent;
  public appService = inject(AppService);
  public ixKeyboardShortcutsService = inject(IxKeyboardShortcutsService);
  protected ixNgNavigationService = inject(IxNgNavigationService);
  protected ixNgComValidationService = inject(IxNgComValidationService);
  public ixNgHtmlUtilsService = inject(IxNgHtmlUtilsService);
  protected ixNgConfirmationService = inject(IxNgConfirmationService);
  protected ixNgMenuService = inject(IxNgMenuService);
  public ixNgShortcutsService = inject(IxNgShortcutsService);
  protected layoutService = inject(LayoutService);
  public blockUiService = inject(BlockUiService);
  public renderer = inject(Renderer2);
  public ixNgFavoriteListService = inject(IxNgFavoriteListService);
  public ixNgValidationService = inject(IxNgValidationService);
  documentClickListener?: () => void;

  ngOnInit(): void {
    const ks = this.ixKeyboardShortcutsService;
    const b: ShortcutBindings = {};
    const openMainMenu = ks.userShortcuts['openMainMenu'];
    const search = ks.userShortcuts['search'];
    const _newDocument = ks.userShortcuts['newDocument'];
    const shortcuts = ks.userShortcuts['shortcuts'];
    const focusNext = ks.userShortcuts['focusNext'];
    const toggleSideMenu = ks.userShortcuts['toggleSideMenu'];

    ks.addShortcut(b, openMainMenu, (e: KeyboardEvent): void | boolean => {
      if (!IxKeyboardShortcutsService.isEventFromInput(e)) {
        this.ixNgNavigationService.navUp = false;
        this.ixNgMenuService.appMenuOpen = true;
        e.preventDefault();
        return false;
      }
    });
    ks.addShortcut(b, search, (e: KeyboardEvent): void | boolean => {
      if (!IxKeyboardShortcutsService.isEventFromInput(e)) {
        if (this.appTopBar && this.appTopBar.inputSearch) {
          this.ixNgNavigationService.navUp = false;
          setTimeout(() => {
            this.appTopBar?.inputSearch?.nativeElement.focus();
          }, 0);
        }
        e.preventDefault();
        return false;
      }
    });

    ks.addShortcut(b, shortcuts, (e: KeyboardEvent): void | boolean => {
      if (!IxKeyboardShortcutsService.isEventFromInput(e)) {
        this.ixNgShortcutsService.appShortcutsOpen = !this.ixNgShortcutsService.appShortcutsOpen;
        e.preventDefault();
        return false;
      }
    });
    ks.addShortcut(b, focusNext, (e: KeyboardEvent): void | boolean => {
      IxKeyboardShortcutsService.focusNextInput(e);
      return true;
    });
    ks.addShortcut(b, toggleSideMenu, (e: KeyboardEvent): void | boolean => {
      this.ixNgHtmlUtilsService.onMenuButtonClick(e);
      return false;
    });

    ks.listenShortcut(b, {
      priority: PRIORITY_GLOBAL,
      // Optional configurations.
      terminal: true, // Default match.
      inputs: true, // Default false.
    });
  }

  ngAfterViewInit() {
    this.documentClickListener = this.renderer.listen('body', 'click', () => {
      if (!this.ixNgMenuService.menuClick && !this.ixNgMenuService.menuButtonClick) {
        this.ixNgMenuService.mobileMenuActive = false;
        this.ixNgMenuService.overlayMenuActive = false;
        this.ixNgMenuService.resetSlim = true;
      }

      this.ixNgMenuService.menuClick = false;
      this.ixNgMenuService.menuButtonClick = false;
    });
  }

  ngOnDestroy(): void {
    // remove the listener
    this.documentClickListener?.();
    this.documentClickListener = undefined;
  }

  sideMenuOpen() {
    return this.ixNgNavigationService.navComponentType && !this.ixNgMenuService.staticMenuInactive;
  }

  isDevMode(): boolean {
    return isDevMode();
  }
}
